












import { ErrorCode, ErrorSeverity, ThrowErrorFunction, isDownstreamErrorCode } from "~/modules/error";
import { HttpAdapter } from "~/backend/HttpAdapter/HttpAdapter";
import { AuthenticationMethod } from "~/backend/commons/authenticationMethods";
import { throwFlexSdkError } from "~/modules/error/ThrowError/ErrorHelper";
import { SimpleHttpAdapterImpl } from "~/backend/SimpleHttpAdapter/SimpleHttpAdapterImpl";
import { ContextManager } from "~/modules/contextManager/ContextManager";

import { TokenInfoResponse } from "../model/tokenInfoResponse";

import { FlexUserService }  from "./flexUser.serviceInterface";

export class FlexUserServiceImpl implements FlexUserService {
    private simpleHttpAdapter: HttpAdapter;

    readonly #throwError: ThrowErrorFunction;

    constructor(ctx: ContextManager) {
        this.simpleHttpAdapter = new SimpleHttpAdapterImpl(ctx);
        this.#throwError = throwFlexSdkError(ctx);
        this.simpleHttpAdapter.setIsEdgeSupported(true);

    }

    






    public async getTokenInfo(accountSid: string, body: string, options?: object): Promise<TokenInfoResponse> {
        const metadata = {
            module: "backend",
            severity: ErrorSeverity.Error,
            source: "flexUser.service.ts"
        };
        if (accountSid === null || accountSid === undefined) {
            this.#throwError(ErrorCode.InvalidParams, metadata, "Required parameter accountSid was null or undefined.");
        }
        if (body === null || body === undefined) {
            this.#throwError(ErrorCode.InvalidParams, metadata, "Required parameter body was null or undefined.");
        }

        let response;
        try {
            response = await this.simpleHttpAdapter.post<TokenInfoResponse>(`https://flex-api[region].twilio.com/v1/Accounts/${encodeURIComponent(String(accountSid))}/Tokens/Info`, AuthenticationMethod.Basic, body, options, "application/x-www-form-urlencoded");
        } catch (e) {
            if (isDownstreamErrorCode(e.code)) {
                const message = `FlexUserService - ${e.message}`
                return this.#throwError(ErrorCode.DownstreamServiceError, metadata, message) as unknown as Promise<never>;;
            }

            return Promise.reject(e)
        }
        return response;
    }
}

